import { Alert, Stack } from '@mantine/core';
import type { ShipmentListProps } from './types';
import ShipmentCard from './ShipmentCard';

const ShipmentList = ({ shipments, renderActionButton }: ShipmentListProps & { renderActionButton?: (shipment: any) => React.ReactNode }) => {
    // Safety check for shipments array
    if (!shipments || !Array.isArray(shipments)) {
        return (
            <Alert color="red" title="Error loading shipments">
                There was a problem loading your shipments. Please try refreshing the page.
            </Alert>
        );
    }

    // Filter out any potentially undefined items for extra safety
    const validShipments = shipments.filter(Boolean);

    return (
        <Stack gap="md">
            {validShipments.map((shipment: any) => (
                <ShipmentCard key={`${shipment.id}-${shipment.type}`} shipment={shipment} actionButton={renderActionButton ? renderActionButton(shipment) : null} />
            ))}
        </Stack>
    );
};

export default ShipmentList;
